import gql from 'graphql-tag'

export const employeeAppointmentsQuery = gql`
	query employeeAppointments($input: EmployeeQueryInput!, $appointmentsInput: AppointmentsInput) {
		employee(input: $input) {
			id
			appointments(input: $appointmentsInput) {
				id
				startTime
				endTime
				price
				source {
					id
					type
				}
				customer {
					id
					firstName
					lastName
					profile {
						firstName
						lastName
					}
				}
				services {
					id
					name
				}
			}
		}
	}
`
